import React, { useEffect } from "react";
import { connect } from "react-redux";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import CurrencyFormatter from "currency-formatter";
import _ from "lodash";
import {primary} from "../../../../../assets/colorPallet";
import BVAInput from "../../../../../components/BVAInput/BVAInput";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const TableRow = (row, index, array, props) => {
  let lastIndex = array.length - 1;
  return (
    <React.Fragment key={index}>
      <Grid
        container
        columnSpacing={0.5}
        justifyContent="center"
        direction="row"
      >
        <Grid item xs={row.manuality ? 6 : 8} sm={row.manuality ? 3 : 4}>
          <Item style={{ textAlign: "start", fontWeight: row.fontWeight ? "bold" : "" }}>
            {row.head}
          </Item>
        </Grid>
        {row.manuality && <Grid item xs={2} sm={1}>
          <FormControl fullWidth variant="standard" sx={{ m: 0.2 }}>
            <Select
              value={row.manualType}
              onChange={(e) => props.onChange(e.target.value, "manualType", index, props.data.title)}
            >
              <MenuItem value={"Auto"}>Auto</MenuItem>
              <MenuItem value={"Manual"}>Manual</MenuItem>
            </Select>
          </FormControl>
        </Grid>}
        <Grid item xs={4} sm={2}>
          {row.manualType == "Manual" ?
            <div className="flex justify-between">
              <div />
              <BVAInput
                textAlign="end"
                variant="standard"
                sx={{ m: 0.6, width: 120 }}
                size="small"
                value={row.value}
                startAdornment={row.type === "percent" ? false : true}
                endAdornment={row.type === "percent" ? true : false}
                startAdornmentLabel="$"
                endAdornmentLabel="%"
                onChange={(val) =>
                  props.onChange(Number(CurrencyFormatter.unformat(val, { code: "USD" })), "value", index, props.data.title)
                }
              />
            </div>
          :
            <Item style={{ textAlign: "right", fontWeight: row.fontWeight ? "bold" : "" }}>
              {row.type ?
                row.type == "ratio"
                  ? row?.value?.toFixed(2) + "x"
                  : row.type == "percent" ? row?.value?.toFixed(2) + "%" : row.value
              :
                (row.value < 0 ? "(" : "") +
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                    roundingMode: "halfExpand",
                  }).format(Math.abs(row.value))
                + (row.value < 0 ? ")" : "")
              }
            </Item>
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default function SingleHead(props) {
  let titleColor = props.titleColor ? props.titleColor : primary;
  const textColor = "white";
  return (
    <Box sx={{ flexGrow: 1 }} paddingTop={1}>
      <Grid container rowGap={0.5} direction="column">
        <Grid container spacing={0.5} justifyContent="center" direction="row">
          <Grid item xs={12} sm={6}>
            <Item
              style={{
                fontWeight: "bold",
                color: textColor,
                backgroundColor: titleColor,
              }}
            >
              {props?.data?.title}
            </Item>
          </Grid>
        </Grid>
        {props?.data?.rows?.map((row, index, array) => (
          TableRow(row, index, array, props)
        ))}
      </Grid>
    </Box>
  );
}
